import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomCard from "../../../../components/CustomCard";
import RowCardText from "../../../../components/RowCardText";
import {EMPTY_VALUES} from "../../../../Apis/functions";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * One failed row of the white list import, same card as the excel import errors
 * of the other modules but with the resident columns the endpoint returns.
 *
 * @param {number} props.number - Position of the card inside the errors grid.
 * @param {Object} props.failure - Failed row returned by the create all endpoint.
 * @param {string} props.description - Reason of the failure already translated.
 * @returns {JSX.Element}
 */
const WhiteListErrorCard = ({ number, failure, description }) => {
    const { t } = useTranslation();

    return (
        <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4'>
            <CustomCard>
                <RowCardText title={t('N°')} value={number || EMPTY_VALUES.DEFAULT} />
                <RowCardText title={t('ROW')} value={failure?.rowNumber ||  EMPTY_VALUES.DEFAULT} />
                <RowCardText title={t('name')} value={failure?.name ||  EMPTY_VALUES.DEFAULT} />
                <RowCardText title={t('last_name')} value={failure?.lastName ||  EMPTY_VALUES.DEFAULT} />
                <RowCardText title={t('email')} value={failure?.email ||  EMPTY_VALUES.DEFAULT} tooltip={failure?.email} />
                <RowCardText title={t('apartment')} value={failure?.apartment ||  EMPTY_VALUES.DEFAULT} />
                <RowCardText title={t('DESCRIPTION')} value={description ||  EMPTY_VALUES.DEFAULT} tooltip={description} />
            </CustomCard>
        </div>
    );
};

export default WhiteListErrorCard;
